import {gql} from '@apollo/client';
import {ArtworkComplete} from './ArtworkCompleteFragment';

export const CatalogSongComplete = {
  catalogSong: gql`
    fragment CatalogSongComplete on Song {
      id
      name
      trackNumber
      explicit
      albumName
      artistName
      duration
      releaseDate
      artwork {
        ...ArtworkComplete
      }
      likes
      liked
    }
    ${ArtworkComplete.artwork}
  `,
};
